export default "__VITE_ASSET__dOMz3ZFs__"